import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import {
  SaleDrugItem,
  SaleImport,
  SelectDrug,
  SelectDrugValidation,
  TechnicalRight,
  TechnicalRightViewModel,
} from '../../models/select-drug';
import { LoggerService } from 'src/app/services/logger.service';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { UserApiService } from '../../services/user-api.service';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { FloatLabelType } from '@angular/material/form-field';
import { FormControl, FormGroup } from '@angular/forms';
import {
  PCTableInputModel,
  PCTableOutputModel,
} from '../../models/pc-table-input-model';
import { PCTableActionInputModel } from '../../models/pc-table-action-input-model';
import { PCSearchRequestModel } from '../../models/pc-search-request-model';
import { TabelPaging } from '../../interfaces/table';
import { CustomizeResponseService } from '../../services/customize-response.service';
import { SelectDrugChangePrice } from '../../models/select-drug-change-price';
import { Router } from '@angular/router';
import { WarehouseModal } from '../../models/warehose-modal';
import { debounceTime } from 'rxjs/operators';
import { NumericService } from 'src/app/services/numeric.service';
import { SaleFactorType } from 'src/app/enum/sale-factor-type';

@Component({
  selector: 'app-sale-factor',
  templateUrl: './sale-factor.component.html',
  styleUrls: ['./sale-factor.component.css'],
})
export class SaleFactorComponent implements OnInit {
  public constructor(
    private logger: LoggerService,
    private modalService: NgbModal,
    private apiService: UserApiService,
    private renderer: Renderer2,
    public numericService: NumericService,
    public router: Router,
    private responseService: CustomizeResponseService
  ) {
    
    this.backendJson = new SaleImport('0');
    this.backendJsonChange = new SelectDrugChangePrice(0, 0, '');
    this.requestModel = new PCSearchRequestModel();
    this.searchRequestModel = new PCSearchRequestModel();
    this.data = new PCTableInputModel(this.searchList, [], false, 1);
    this.thisItemOnStock = new WarehouseModal(
      '',
      0,
      '',
      '',
      0,
      '',
      '',
      '',
      '',
      ''
    );
    this.GetInsurance();

    this.renderer.listen('window', 'keyup', (e: any) => {
      if (e.key == 'F8') {
        this.router.navigate(['/ElectronicPrescription']);
      }

      if (this.level == 2 || this.level == 1) {
        if (
          e.key == 'Enter' &&
          this.modalIsOpen == false &&
          this.tosale == true
        ) {
          this.nextFocus();
        }

        if (e.key == 'F2' || e.key == "PrintScreen") {
          this.print();
          return;
        }
      }

      if (this.level == 1) {
        if (e.key == '-') {
          return;
        }
      }

      if (this.level == 1) {
        if (e.key == '-') {
          this.backendJson.patientMobileNumber = '';
          this.barcodeElement.nativeElement.focus();
          this.level = 2;
          return;
        }
      }

      if (this.level == 3) {
        if (e.key == 'F2') {
          let el: HTMLElement = this.printBtnElement.nativeElement;
          el.click();
        }
        if (e.key == '+') {
          this.goToAddPage('viewCard');
        }
      }
      if (e.key == 'o' && e.altKey) {
        this.backendJson.insurance = 'OTC';
        this.allFactorWithTechnical();
      }
      if (e.key == 'p' && e.altKey) {
        this.backendJson.insurance = 'PSC';
        this.allFactorWithTechnical();
      }
    });

    this.drugSearchForm = new FormGroup({
      drugBrandName: new FormControl(''),
    });

    this.itemValidation = new SelectDrugValidation();

    this.isFastSale = false;
  }

  @Input() isFastSale: boolean;
  @Input() level?: number;
  @Output() parentActionOutput = new EventEmitter<PCTableOutputModel>();

  public drugSearchForm: FormGroup;
  floatLabelControl = new FormControl('always' as FloatLabelType);
  public selectDrugList: SelectDrug[] = [];
  public editableItem: SelectDrug = new SelectDrug();
  public searchWithBarcode: string = ``;
  public data?: PCTableInputModel;
  public technicalRight?: TechnicalRightViewModel;
  public technicalRightIsFree: boolean = true;
  public insuranceNeedPersoalId: number = 0;
  public userCode?: string | null;

  @ViewChild('search') searchElement!: ElementRef;
  @ViewChild('organizationElement') organizationElement!: ElementRef;
  @ViewChild('count') countElement!: ElementRef;
  @ViewChild('nationalid') nationalCodeElement!: ElementRef;
  @ViewChild('barcode') barcodeElement!: ElementRef;
  @ViewChild('drugSearchModal') drugSearchModalElement!: ElementRef;
  @ViewChild('printModal') printModalElement!: ElementRef;
  @ViewChild('TaminModal') TaminModalElement!: ElementRef;
  @ViewChild('printBtn') printBtnElement!: ElementRef;
  @ViewChild('datePicker') popoverDataPicker!: NgbPopover;
  @ViewChild('ScanBarcodeModal') ScanBarcodeModal!: ElementRef;

  public changePriceLoading: boolean = false;
  public searchLoading: boolean = false;
  public searchList: SelectDrug[] = [];
  public insuranceList: any[] = [];
  public finalDrugList: any[] = [];

  public modalIsOpen: boolean = false;
  public modalWarehouseIsOpen: boolean = false;
  public recept: any;
  public backendJson: SaleImport;
  public backendJsonChange: SelectDrugChangePrice;
  public requestModel: PCSearchRequestModel;
  public endPoint: string = 'SaleFactor';
  public endPointUrl!: string;
  public tosale: boolean = true;
  public InventoryList!: any;
  public monthName: string = '';
  public isfactor: boolean = false;
  public otcField: boolean = false;
  public modalLoading: boolean = false;
  public modalSuccessConfirm: boolean = false;
  public loading: boolean = true;
  public apiResponse: any[] = [];
  public listLoading: boolean = true;
  public thisItemOnStock: WarehouseModal;
  public countMessage: string = ``;
  public newItem: any = { count: '', stockId: '' };
  public searchRequestModel: PCSearchRequestModel;
  public itemValidation: SelectDrugValidation;
  public searchdata?: PCTableInputModel;
  public searchPaging?: TabelPaging;
  public activeSerch: boolean = true;
  public receptModalIsOpen: boolean = false;
  public prescriptionHasMilkPower: boolean = false;
  public sideBoxClass: string = 'side-box-open';
  public selectValue: any;

  private focusableItems: string[] = [
    'PatientNationalCode',
    'PatientFullname',
    'PatientMobileNumber',
    'DocktorFullName',
    'medicalsystemcode',
    'DrugGenricName',
    'count',
    'Discount',
    'save-button',
    'clear-button',
  ];

  public ngOnInit(): void {
    this.TechnicalRight();
    if (this.level == null) {
      this.level = 1;
    }
    this.nextFocus();

    const width = window.innerWidth;
    if (width <= 960) {
      this.changeSideBoxState();
    }
    this.drugSearchForm
      .get('drugBrandName')
      ?.valueChanges.pipe(debounceTime(1000))
      .subscribe((value) => {
        if (this.activeSerch) {
          this.searchDrug(value);
        } else {
          this.activeSerch = true;
        }
      });
  }

  public openWarehoseHandelingModal(item: WarehouseModal) {
    this.modalWarehouseIsOpen = true;
    this.thisItemOnStock = item;
  }

  public parentAction(event: PCTableOutputModel) {
    switch (event.action) {
      case 'ReteyListView':
        this.getCheckInventory(event.data);
        this.modalWarehouseIsOpen = false;
        break;
      case 'TransferModalClose':
        this.modalWarehouseIsOpen = false;
        break;
      case 'PrintItem':
        this.getDetailPrint(event.data.id);
        break;
      case 'Create':
        this.goToAddPage('listCard');
        break;
      case 'ClosePrintModal':
        this.clearAddPage();
        break;
      case 'closeUid':
        this.modalService.dismissAll();
        break;
      case 'SaveUid':
        this.selectValue.drugUIds = event.data;
        this.modalService.dismissAll();
        break;
      default:
        break;

    }
  }

  public getDetailPrint(itemID: string) {
    try {
      this.listLoading = true;
      let url = `${this.endPoint}/Print/${itemID}`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getSingleItem(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(this.endPointUrl, result, `Get All`);
          if (result.succeeded) {
            this.recept = result.data;
            console.log(this.recept);
            this.goToViewPage();
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.listLoading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.listLoading = false;
        },
        () => {
          this.listLoading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.listLoading = false;
    }
  }

  public openModal(content: any) {
    try {
      this.modalService
        .open(content, { ariaLabelledBy: 'modal-basic-title', size: 'xl' })
        .result.then(
          (result) => {
            if (result == 'Save click') {
            }
            setTimeout(() => {
              this.modalIsOpen = false;
            }, 1 * 1000);
          },
          (reason) => {
            setTimeout(() => {
              this.modalIsOpen = false;
            }, 1 * 1000);
          }
        );
    } catch (error) { }
  }

  public changeMonth(val: string) {
    if (this.popoverDataPicker.isOpen()) {
      this.popoverDataPicker.close();
    }
    this.monthName = val;
  }

  public print() {
    try {
      this.loading = true;

      this.backendJson.saleFactorType = SaleFactorType.FreePrescription;

      if (this.backendJson.drugList.length == 0) {
        this.logger.addError('Drug List is Empty', false);
        this.loading = false;
        return;
      }

      let isValidate = true;

      this.backendJson.drugList.forEach(element => {
        if (element.drugUIds == undefined) {
          this.logger.addError(`برای دارو ${element.brandName} بارکد تعریف نشده است.`, false);
          isValidate = false;
        }

       
      });

      if (!isValidate) {
        return;
      }

      let url = `${this.endPoint}/SaleImport`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        this.loading = false;
        return;
      }

      this.apiService
        .postItem(new ApiRequestModel(url, this.backendJson))
        .subscribe(
          (result) => {
            if (result.succeeded) {
              this.recept = result.data;
              this.isfactor = true;
              this.goToViewPage();
            } else {
              this.logger.addBackEndMessage(result);
            }
            this.loading = false;
          },

          (error) => {
            this.apiService.AddErrorLog(error);
            this.loading = false;
          },
          () => {
            this.loading = false;
          }
        );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public goToViewPage() {
    this.receptModalIsOpen = true;
  }

  public goToAddPage(cardId: string) {
    let selectStockPage = document.getElementById(cardId);
    if (selectStockPage) {
      selectStockPage.classList.add('animate__backOutDown');
    }

    this.clearAddPage();
    setTimeout(() => {
      this.level = 1;
    }, 700);

    setTimeout(() => {
      this.barcodeElement.nativeElement.focus();
    }, 2 * 1000);
  }

  public goToListPage(cardId: string) {
    let selectStockPage = document.getElementById(cardId);
    if (selectStockPage) {
      selectStockPage.classList.add('animate__backOutDown');
    }

    setTimeout(() => {
      this.level = 0;
    }, 700);

    this.listLoading = true;
  }

  public parentSearchAction(event: PCTableOutputModel) {
    switch (event.action) {
      case 'Sort':
        this.listLoading = true;
        if (this.searchRequestModel.orderBy == '') {
          this.searchRequestModel.direction = 'asd';
        } else if (this.searchRequestModel.orderBy != event.data) {
          this.searchRequestModel.direction = 'asd';
        } else if (this.searchRequestModel.direction == '') {
          this.searchRequestModel.direction = 'asd';
        } else if (this.searchRequestModel.direction == 'asd') {
          this.searchRequestModel.direction = 'desc';
        }

        this.searchRequestModel.orderBy = event.data;

        this.searchDrug(this.editableItem.persianName!);
        break;
      case 'Paging':
        this.listLoading = true;

        this.searchRequestModel.pageNumber = event.data;
        this.searchDrug(this.editableItem.persianName!);
        break;
      case 'PageSize':
        this.listLoading = true;
        this.searchRequestModel.pageSize = event.data;
        this.searchDrug(this.editableItem.persianName!);
        break;
      case 'SelectItem':
        this.selectDrug(event.data);
        this.modalService.dismissAll();
        break;
      default:
        break;
    }
  }

  public searchDrug(drugName: string): void {
    try {
      if (drugName == `` || !drugName) {
        this.editableItem.inventory = 0;
        this.editableItem.buyPrice = 0;
        this.editableItem.sellPrice = 0;
        this.editableItem.paidPrice = 0;
        return;
      }

      if (this.modalIsOpen == false) {
        this.modalIsOpen = true;
      }

      let url = ``;

      if (this.isFastSale) {
        url = `EssentialsAndCosmetic/AdvanceSearchWithoutChemicalDrug?search=${drugName}&pageNumber=${this.searchRequestModel.pageNumber}&pageSize=${this.searchRequestModel.pageSize}&paging=${this.searchRequestModel.paging}&orderBy=${this.searchRequestModel.orderBy}&direction=${this.searchRequestModel.direction}&search=${drugName}`;
      } else {
        url = `SaleFactor/AdvanceSearch?search=${drugName}&pageNumber=${this.searchRequestModel.pageNumber}&pageSize=${this.searchRequestModel.pageSize}&paging=${this.searchRequestModel.paging}&orderBy=${this.searchRequestModel.orderBy}&direction=${this.searchRequestModel.direction}&search=${drugName}`;
      }

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.searchdata = new PCTableInputModel(
        [],
        [],
        true,
        1,
        this.requestModel.orderBy,
        this.requestModel.direction
      );
      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded) {
            let firstItemOnPage = 1;
            if (result.data?.firstItemOnPage) {
              firstItemOnPage = result.data?.firstItemOnPage;
            }

            if (result.data?.pageCount!<result.data?.pageNumber!) {
              this.requestModel.pageNumber = 1;
            }
            this.searchdata = new PCTableInputModel(
              result.data?.items.map((current) => ({
                id: current.id,
                count: current.count,
                lot: current.lot,
                expierDate: current.expierDate,
                stockId: current.stockId,
                stockItemId: current.id,
                stockName: current.stockName,
                drugId: current.drugId,
                drugGenricName: current.drugGenricName,
                drugGenricCode: current.drugGenricCode,
                drugBrandName: current.drugBrandName,
                drugBrandPersianName: current.drugBrandPersianName,
                country: current.country,
                sellPrice: current.sellPrice,
                minimumCount: current.minimumCount,
                minimumDigitalCount: current.minimumDigitalCount,
                erxCode: current.erxCode,
                drugPackageCount: current.drugPackageCount,
                drugPackage: current.drugPackage,
                keepingType: current.keepingType,
                companyName: current.companyName,
                rowColor: current.count == 0 ? 'Danger' : '',
              })),
              [],
              true,
              firstItemOnPage,
              this.requestModel.orderBy,
              this.requestModel.direction
            );

            this.searchPaging = this.responseService.customizePaging(result);
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.searchLoading = false;
        },
        () => { }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.searchLoading = false;
    }
  }

  public searchBarcode(): void {
    try {
      this.searchLoading = true;

      if (!this.searchWithBarcode) {
        return;
      }

      if (this.searchWithBarcode.length < 3) {
        return;
      }

      var barcode = this.getGTN();

      this.searchWithBarcode = ``;
      let url = `DrugItem?barcode=${barcode}`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getWitoutPage(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded) {
            if (!result.data) {
              this.searchList = [];
            } else if (result.data.length == 0) {
              this.searchList = [];
            } else {
              var foundedDuplicate = this.selectDrugList.find(
                (current) => current.genericCode == result.data![0].genericCode
              );

              if (foundedDuplicate != undefined) {
                if (foundedDuplicate.count == undefined) {
                  foundedDuplicate.count = 1;
                } else {
                  foundedDuplicate.count++;
                }

                if (foundedDuplicate.sellPrice == undefined) {
                  return;
                }

                //this.backendJson.totalPrice += foundedDuplicate.sellPrice!;

                foundedDuplicate.paidPrice =
                  foundedDuplicate.sellPrice * foundedDuplicate.count;
                return;
              }

              var thisItem: SelectDrug = result.data![0];
              thisItem.count = 1;
              //this.backendJson.totalPrice += thisItem.sellPrice!;
              thisItem.paidPrice = thisItem.sellPrice;
              this.selectDrugList.push(thisItem);
              setTimeout(() => {
                this.logger.clearWarning();

                this.barcodeElement.nativeElement.focus();
              }, 2 * 1000);
            }
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.searchLoading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.searchLoading = false;
        },
        () => { }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.searchLoading = false;
    }
  }

  public selectDrug(item: any) {
    if (item.count == 0) {
      this.logger.addWarning(`محصول ${item.drugBrandName} موجودی ندارد`, false);
      return;
    }

    this.prescriptionHasMilkPower = item.drugGenricName == 'Milk Powder';

    this.itemValidation.drugNameMessage = undefined;

    this.editableItem.stockId = item.stockId;
    this.editableItem.stockName = item.stockName;
    this.editableItem.drugId = item.drugId;
    this.editableItem.genericCode = item.drugGenricCode;
    this.editableItem.genericName = item.drugGenricName;
    this.editableItem.brandName = item.drugBrandName;
    this.editableItem.erx = item.erxCode;
    this.editableItem.persianName = item.drugBrandPersianName;
    this.editableItem.name = item.drugBrandName;
    this.editableItem.countryName = item.country;
    this.editableItem.drugPackageCount = item.drugPackageCount;
    this.editableItem.sellPrice = item.sellPrice;
    this.editableItem.expireDate = item.expierDate;
    this.editableItem.companyName = item.companyName;
    this.editableItem.buyPrice = item.buyPrice;
    this.editableItem.inventory = item.count;
    this.editableItem.id = item.id;
    this.editableItem.stockItemId = item.stockItemId;
    this.calcRow();

    var foundedDuplicate = this.selectDrugList.find(
      (current) => current.id == item.id
    );

    if (foundedDuplicate != undefined) {
      if (foundedDuplicate.count == undefined) {
        foundedDuplicate.count = 1;
      } else {
        foundedDuplicate.count++;
      }

      this.allFactor();

      this.modalIsOpen = false;
      this.activeSerch = false;
      return;
    }

    this.getCheckInventory(item.drugId);

    this.modalIsOpen = false;
    this.activeSerch = false;
    return;
  }

  public connectToWebApi() {
    this.logger.addWarning('Cannot connect to webapi ', false);
    this.level = 2;
    setTimeout(() => {
      this.logger.clearWarning();
      this.backendJson.patientNationalCode = 'نسخه آزاد';
      this.barcodeElement.nativeElement.focus();
    }, 2 * 1000);
  }

  private getGTN() {
    if (this.searchWithBarcode == null) {
      return null;
    }

    if (this.searchWithBarcode.length < 18) {
      return null;
    }

    var barcode = this.searchWithBarcode.substring(2, 16);

    return barcode;
  }

  public insideTableAction(event) {
    if (event.action == 'SelectItem') {
      this.selectDrug(event.data);
      this.modalService.dismissAll();
    }
  }

  public calcCount() {
    this.editableItem.count =
      this.editableItem.packageCount * this.editableItem.drugPackageCount;
    if (this.editableItem.count == 0) {
      this.itemValidation.countMessage = `حداقل میزان خرید 1 عدد می باشد`;
    } else if (this.editableItem.count > this.editableItem.inventory) {
      this.itemValidation.countMessage = `کمبود موجودی انبار`;
    } else {
      this.itemValidation.countMessage = undefined;
    }
  }

  public calcFactor() {
    this.editableItem.elementPrice =
      this.editableItem.sellPrice * this.editableItem.count -
      this.editableItem.discount;

    this.editableItem.paidPrice =
      this.editableItem.elementPrice -
      this.editableItem.insurancePrice -
      this.editableItem.shareCurrencyPrice;
  }

  public calcDiscount(changePercent: boolean) {
    const totalPrice = this.editableItem.sellPrice * this.editableItem.count;
    if (changePercent) {
      if (this.editableItem.discountPercent > 100) {
        this.editableItem.discountPercent = 100;
      }
      
      let remainder=
        (totalPrice*this.editableItem.discountPercent)%100;

        
        let newTotalPrice=totalPrice-remainder;
        
        this.editableItem.discount=
          (newTotalPrice*this.editableItem.discountPercent)/100;

    } else {
      if (totalPrice < this.editableItem.discount) {
        this.editableItem.discount = totalPrice;
      }

      this.editableItem.discountPercent =
        (this.editableItem.discount * 100) / totalPrice;
    }

    this.calcFactor();
  }

  public calcRow() {
    this.calcCount();
    this.calcFactor();
  }

  public checkTechnicalRight() {
    if (this.backendJson.insurance == 'OTC') {
      if (this.technicalRight == null) {
        this.logger.addError('Please refresh page', false);
        return;
      }
      this.backendJson.documentType = '0';
      this.backendJson.technicalRight = this.technicalRight.otc.amount;
      this.backendJson.insuranceTechnicalRight = 0;
    } else {
      if (this.technicalRight == null) {
        this.logger.addError('Please refresh page', false);
        return;
      }
      this.backendJson.technicalRight = this.technicalRight.free.amount;

      if (this.backendJson.insurance == 'PSC') {
        this.backendJson.documentType = '3';
        this.backendJson.insuranceTechnicalRight = 0;
      } else {
        this.backendJson.documentType = '1';
        this.backendJson.insuranceTechnicalRight =
          this.technicalRight.free.amount;
      }
    }
  }

  public allFactorWithTechnical() {
    this.checkTechnicalRight();
    this.allFactor();
  }

  public allFactor() {
    this.backendJson.elementPrice = 0;
    this.backendJson.prescriptionPrice = 0;
    this.backendJson.insurancePrice = 0;
    this.backendJson.shareCurrencyPrice = 0;
    this.backendJson.totalInsurance = 0;
    this.backendJson.paidPrice = 0;

    this.backendJson.drugList.forEach((element) => {
      this.backendJson.elementPrice += element.elementPrice;
      this.backendJson.insurancePrice += element.insurancePrice;
      this.backendJson.shareCurrencyPrice += element.shareCurrencyPrice;
      this.backendJson.paidPrice += element.paidPrice;
    });

    this.backendJson.prescriptionPrice =
      this.backendJson.elementPrice + this.backendJson.technicalRight;

    this.backendJson.totalInsurance =
      this.backendJson.insurancePrice +
      this.backendJson.shareCurrencyPrice +
      this.backendJson.insuranceTechnicalRight;

    this.backendJson.paidPrice =
      this.backendJson.prescriptionPrice - this.backendJson.totalInsurance;
  }

  public getCheckInventory(id: any) {
    try {
      this.loading = true;

      let url = `Stockitem/ListView/${id}`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getWitoutPage(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded) {
            if (result.data == null) {
              return;
            }
            this.InventoryList = result.data.map(
              (current) =>
                new WarehouseModal(
                  current.id,
                  current.count,
                  current.expierDate,
                  current.drugId,
                  current.drugPackageCount,
                  current.companyName,
                  current.drugBrandName,
                  current.stockName,
                  current.stockId,
                  current.id
                )
            );
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => { }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public TechnicalRight() {
    try {
      if (this.isFastSale == true) {
        this.technicalRight = {
          "otc": {
            "id": "9ae33d0b-4ddc-45ec-89a9-901f61285c1e",
            "name": "حق فنی OTC",
            "isOTC": true,
            "isHoliday": false,
            "startTime": "08:00:00",
            "endTime": "20:00:00",
            "amount": 0
          },
          "free": {
            "id": "d864b74f-6755-4ec7-9950-25a64c9e2e68",
            "name": "حق فنی نسخه",
            "isOTC": false,
            "isHoliday": false,
            "startTime": "08:00:00",
            "endTime": "20:00:00",
            "amount": 0
          }
        }
        return;
      }
      this.loading = true;

      let url = `TechnicalRight/Now`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getSingleItem(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded) {
            this.technicalRight = result.data;
            this.allFactorWithTechnical();
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => { }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public GetInsurance() {
    try {
      this.loading = true;

      let url = `Insurance?pageNumber=1&pageSize=1000&paging=false&orderBy=&direction=asc`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getWitoutPage(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded) {
            this.insuranceList = result.data!.map((current) => ({
              id: current.id,
              name: current.name,
              persianName: current.persianName,
            }));
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => { }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public remove(index) {
    this.backendJson.drugList.splice(index, 1);
    this.allFactor();
  }

  public EditPrice() {
    this.backendJsonChange = new SelectDrugChangePrice(
      this.editableItem.sellPrice,
      this.editableItem.sellPrice,
      this.editableItem.drugId
    );
    this.tosale = false;
  }

  public SaveEditPrice() {
    try {
      if (
        this.backendJsonChange?.newPrice == this.backendJsonChange?.oldPrice
      ) {
        this.tosale = true;
        return;
      }
      this.changePriceLoading = true;
      let url = `DrugPriceChangeLog/ChangePrice`;

      const backendJson =
      {
        oldBuyPrice: this.editableItem.buyPrice,
        newBuyPrice: this.editableItem.buyPrice,
        oldSellPrice: this.backendJsonChange?.oldPrice,
        newSellPrice: this.backendJsonChange?.newPrice,
        drugId: this.editableItem.drugId,
      };

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        this.changePriceLoading = false;
        return;
      }

      this.apiService
        .postItem(new ApiRequestModel(url, backendJson))
        .subscribe(
          (result) => {
            if (result.succeeded) {
              this.editableItem.sellPrice = this.backendJsonChange.newPrice;
              this.calcFactor();
            } else {
              this.logger.addBackEndMessage(result);
            }
            this.tosale = true;
            this.changePriceLoading = false;
          },

          (error) => {
            this.apiService.AddErrorLog(error);
            this.changePriceLoading = false;
          },
          () => {
            this.changePriceLoading = false;
          }
        );
    } catch (e) {
      this.logger.addException(e, true);
      this.changePriceLoading = false;
    }
  }

  public submitModal() {
    try {
      this.modalLoading = true;

      let url = `StockItem/Transfer`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        this.loading = false;
        return;
      }

      var jsonText = JSON.stringify(this.backendJson);
      this.apiService
        .postItem(new ApiRequestModel(url, this.backendJson))
        .subscribe(
          (result) => {
            this.modalLoading = false;
            if (result.succeeded) {
              this.modalService.dismissAll();

              this.modalSuccessConfirm = true;
            } else {
              this.logger.addBackEndMessage(result);
            }
            // this.getData();
          },

          (error) => {
            this.apiService.AddErrorLog(error);
            this.modalLoading = false;
          },
          () => {
            this.modalLoading = false;
          }
        );
    } catch (e) {
      this.logger.addException(e, true);
      this.modalLoading = false;
    }
  }

  public goToCashDesk() {
    this.router.navigate(['backToCash']);
  }

  public confirmNewItem() {
    if (!this.editableItem.drugId && this.editableItem.drugId == '') {
      this.itemValidation.drugNameMessage = `وارد کردن مقدار دارو الزامی است`;
      return;
    }

    this.calcFactor();

    const thisValue = new SaleDrugItem(
      this.editableItem.count,
      this.editableItem.drugId,
      this.editableItem.discount,
      this.editableItem.paidPrice,
      this.editableItem.sellPrice,
      this.editableItem.packageCount,
      this.editableItem.stockItemId,
      this.editableItem.elementPrice,
      this.editableItem.insurancePrice,
      this.editableItem.shareCurrencyPrice
    );

    thisValue.brandName = this.editableItem.brandName;
    thisValue.genericCode = this.editableItem.genericCode;
    thisValue.erx = this.editableItem.erx;
    thisValue.expireDate = this.editableItem.expireDate?.toString();

    this.backendJson.drugList.push(thisValue);
    this.editableItem = new SelectDrug();
    this.allFactor();

    setTimeout(() => {
      this.barcodeElement.nativeElement.focus();
    }, 2);
  }

  public clearNewItem() {
    this.editableItem = new SelectDrug();
  }

  public nextFocus() {
    const needFocus = this.focusableItems[0];
    var thisItem = document.getElementById(`${needFocus}`);
    if (thisItem != null) {
      if (needFocus == 'save-button' || needFocus == 'clear-button') {
        thisItem.focus();

        this.focusableItems = [
          'DrugGenricName',
          'count',
          'Discount',
          'save-button',
          'clear-button',
        ];
      } else {
        this.focusableItems.shift();
        this.focusableItems.push(needFocus);
        thisItem.focus();
      }
    }
  }

  public setOnStockCount() {
    if (this.editableItem.packageCount == null) {
      this.editableItem.packageCount = 0;
    }
    this.newItem.count = this.editableItem.packageCount;
  }

  public clearAddPage() {
    this.selectDrugList = [];
    this.backendJson = new SaleImport('3');
    this.recept = undefined;
    this.receptModalIsOpen = false;
  }

  public changeSideBoxState() {
    switch (this.sideBoxClass) {
      case 'side-box-open':
        this.sideBoxClass = 'side-box-try-close';
        setTimeout(() => {
          this.changeSideBoxState();
        }, 100);
        break;

      case 'side-box-try-close':
        this.sideBoxClass = 'side-box-close';
        break;

      case 'side-box-close':
        this.sideBoxClass = 'side-box-try-open';
        setTimeout(() => {
          this.changeSideBoxState();
        }, 100);
        break;

      case 'side-box-try-open':
        this.sideBoxClass = 'side-box-open';
        break;

      default:
        break;
    }
  }

  public UidScanner(selectDrug: any) {
    this.selectValue = selectDrug;
    this.openModal(this.ScanBarcodeModal);
  }

  public callParent(method: string, data: any) {
    this.parentActionOutput.emit(new PCTableOutputModel(method, data));
  }

}
